import { render, staticRenderFns } from "./Punk.vue?vue&type=template&id=2d1fdd73&scoped=true&"
import script from "./Punk.vue?vue&type=script&lang=js&"
export * from "./Punk.vue?vue&type=script&lang=js&"
import style0 from "./Punk.vue?vue&type=style&index=0&id=2d1fdd73&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d1fdd73",
  null
  
)

export default component.exports